import React from "react"
import { Link, useLocation } from "react-router-dom"
import { useMustRead, isMustReadPath } from "./MustReadProvider"
import { BANNER_HEADING, BANNER_CTA, BANNER_DETAIL, bannerCount } from "helpers/mustReadCopy"
import "./mustRead.css"

const MustReadBanner = () => {
  const { data, dismissBanner } = useMustRead()
  const location = useLocation()

  if (!data?.bannerVisible) return null
  const reviewed = data.reviewed || 0
  const total = data.total || 0
  const outstanding = Math.max(0, total - reviewed)
  if (outstanding === 0) return null

  return (
    <div className="mr-banner" role="region" aria-label="Onboarding reminder">
      <i className="bx bx-list-check mr-banner__icon" aria-hidden="true" />
      <div className="mr-banner__body">
        <p className="mr-banner__heading">{BANNER_HEADING}</p>
        <p className="mr-banner__text">
          <strong className="mr-banner__count">{bannerCount(reviewed, total)}</strong>{" "}
          <span>{BANNER_DETAIL}</span>
        </p>
      </div>
      {!isMustReadPath(location.pathname) && (
        <Link to="/must-read" className="mr-banner__cta">
          {BANNER_CTA}
        </Link>
      )}
      <button type="button" className="mr-banner__close" aria-label="Dismiss for 24 hours" onClick={dismissBanner}>
        <i className="bx bx-x" aria-hidden="true" />
      </button>
    </div>
  )
}

export default MustReadBanner
